import config from '../config';
import apiErrorHandler, { createAxiosInstance } from './apiErrorHandler';

// Create API instance with error handling
const api = createAxiosInstance(config.server.baseUrl);

// Export the API instance
export default api;

// Export error handling utilities
export const { createApiError, handleApiError, retryRequest } = apiErrorHandler; 